import React from "react";
import { FlexColumn, FlexRow, Text } from "../../../styles/Global";
import * as Global from "../../../styles/Global";
import StatBlock from "../StatBlock";
import "../../../App.scss";

const ScoremagicStatsAxethrowing = ({
  data,
  viewType,
  showDPR,
  formatType,
  value,
}) => {
  console.log("ScoremagicStatsAxethrowing data: ", data);
  return (
    <>
      {formatType !== "all" && value > 1 && (
        <FlexRow
          style={{ width: "100%", marginTop: 10 }}
          align="center"
          justify="center"
        >
          <Text
            style={{ fontStyle: "italic", textAlign: "center" }}
            size=".7em"
          >
            {formatType === "all"
              ? "Sandbag %"
              : formatType === "bracket"
              ? "Bracket stat"
              : "Round Robin stat"}{" "}
            tracking began in December 2023
          </Text>
        </FlexRow>
      )}
      <FlexRow
        style={{
          paddingBottom: 10,
          borderRadius: 20,
        }}
        justify="center"
        align="center"
      >
        <StatBlock topText={data.ppr} bottomText="PPR" blur={viewType < 2} />

        <StatBlock
          topText={
            <FlexColumn align="center">
              <Text size="20px" style={{ fontWeight: "700" }}>
                {data.totalaxebullpercent}%
              </Text>
              <Text size="13px">{data.totalaxebull.toLocaleString()}</Text>
            </FlexColumn>
          }
          bottomText="Bullseye"
          blur={viewType < 2}
        />
        <StatBlock
          topText={data.totalRounds.toLocaleString()}
          bottomText="Rounds"
          blur={viewType < 2}
        />
      </FlexRow>
      <FlexRow style={{ marginBottom: 10 }} justify="center">
        <StatBlock
          topText={
            <FlexColumn align="center">
              <Text size="20px" style={{ fontWeight: "700" }}>
                {data.roundWinPercent}%
              </Text>
              <Text size="13px">{data.roundWinTotal.toLocaleString()}</Text>
            </FlexColumn>
          }
          bottomText="Round Win"
          blur={viewType < 2}
        />
        <StatBlock
          topText={
            <FlexColumn align="center">
              <Text size="20px" style={{ fontWeight: "700" }}>
                {data.roundLossPercent}%
              </Text>
              <Text size="13px">{data.roundLossTotal.toLocaleString()}</Text>
            </FlexColumn>
          }
          bottomText="Round Loss"
          blur={viewType < 2}
        />
        <StatBlock
          topText={
            <FlexColumn align="center">
              <Text size="20px" style={{ fontWeight: "700" }}>
                {data.roundTiePercent}%
              </Text>
              <Text size="13px">{data.roundTieTotal.toLocaleString()}</Text>
            </FlexColumn>
          }
          bottomText="Round Tie"
          blur={viewType < 2}
        />

        {formatType === "all" && (
          <StatBlock
            topText={
              <FlexColumn align="center">
                <Text size="20px" style={{ fontWeight: "700" }}>
                  {data.matchTypeDiffPercent}%
                </Text>
                <Text size="13px">{data.matchTypeDiff.toLocaleString()}</Text>
              </FlexColumn>
            }
            bottomText="SB%"
            blur={viewType < 2}
          />
        )}
      </FlexRow>
      <FlexRow justify="center" align="center">
        <Text size="12px" style={{ textAlign: "center", marginTop: 15 }}>
          Rings
        </Text>
      </FlexRow>
      <FlexRow
        style={{
          paddingBottom: 10,
          borderRadius: 20,
        }}
        justify="center"
      >
        <StatBlock
          topText={
            <FlexColumn align="center">
              <Text size="20px" style={{ fontWeight: "700" }}>
                {data.totalaxe0percent}%
              </Text>
              <Text size="13px">{data.totalaxe0.toLocaleString()}</Text>
            </FlexColumn>
          }
          bottomText="0s"
          blur={viewType < 2}
        />
        <StatBlock
          topText={
            <FlexColumn align="center">
              <Text size="20px" style={{ fontWeight: "700" }}>
                {data.totalaxe1percent}%
              </Text>
              <Text size="13px">{data.totalaxe1.toLocaleString()}</Text>
            </FlexColumn>
          }
          bottomText="1s"
          blur={viewType < 2}
        />
        <StatBlock
          topText={
            <FlexColumn align="center">
              <Text size="20px" style={{ fontWeight: "700" }}>
                {data.totalaxe2percent}%
              </Text>
              <Text size="13px">{data.totalaxe2.toLocaleString()}</Text>
            </FlexColumn>
          }
          bottomText="2s"
          blur={viewType < 2}
        />
      </FlexRow>
      <FlexRow
        style={{
          paddingBottom: 10,
          borderRadius: 20,
        }}
        justify="center"
      >
        <StatBlock
          topText={
            <FlexColumn align="center">
              <Text size="20px" style={{ fontWeight: "700" }}>
                {data.totalaxe3percent}%
              </Text>
              <Text size="13px">{data.totalaxe3.toLocaleString()}</Text>
            </FlexColumn>
          }
          bottomText="3s"
          blur={viewType < 2}
        />
        <StatBlock
          topText={
            <FlexColumn align="center">
              <Text size="20px" style={{ fontWeight: "700" }}>
                {data.totalaxe4percent}%
              </Text>
              <Text size="13px">{data.totalaxe4.toLocaleString()}</Text>
            </FlexColumn>
          }
          bottomText="4s"
          blur={viewType < 2}
        />
        <StatBlock
          topText={
            <FlexColumn align="center">
              <Text size="20px" style={{ fontWeight: "700" }}>
                {data.totalaxe5percent}%
              </Text>
              <Text size="13px">{data.totalaxe5.toLocaleString()}</Text>
            </FlexColumn>
          }
          bottomText="5s"
          blur={viewType < 2}
        />
      </FlexRow>
      <FlexRow justify="center" align="center">
        <Text size="12px" style={{ textAlign: "center", marginTop: 15 }}>
          Blue Blocks
        </Text>
      </FlexRow>
      <FlexRow justify="center">
        <StatBlock
          topText={
            <FlexColumn align="center">
              <Text size="20px" style={{ fontWeight: "700" }}>
                {data.totalaxetoppercent}%
              </Text>
              <Text size="13px">{data.totalaxetop.toLocaleString()}</Text>
            </FlexColumn>
          }
          bottomText="9T"
          blur={viewType < 2}
        />
        <StatBlock
          topText={
            <FlexColumn align="center">
              <Text size="20px" style={{ fontWeight: "700" }}>
                {data.totalaxebottompercent}%
              </Text>
              <Text size="13px">{data.totalaxebottom.toLocaleString()}</Text>
            </FlexColumn>
          }
          bottomText="9B"
          blur={viewType < 2}
        />
        <StatBlock
          topText={
            <FlexColumn align="center">
              <Text size="20px" style={{ fontWeight: "700" }}>
                {data.totalaxeleftpercent}%
              </Text>
              <Text size="13px">{data.totalaxeleft.toLocaleString()}</Text>
            </FlexColumn>
          }
          bottomText="8L"
          blur={viewType < 2}
        />
        <StatBlock
          topText={
            <FlexColumn align="center">
              <Text size="20px" style={{ fontWeight: "700" }}>
                {data.totalaxerightpercent}%
              </Text>
              <Text size="13px">{data.totalaxeright.toLocaleString()}</Text>
            </FlexColumn>
          }
          bottomText="8R"
          blur={viewType < 2}
        />
      </FlexRow>
      <FlexRow justify="center" align="center">
        <Text size="12px" style={{ textAlign: "center", marginTop: 15 }}>
          Faults
        </Text>
      </FlexRow>
      <FlexRow s justify="center">
        <StatBlock
          topText={
            <FlexColumn align="center">
              <Text size="20px" style={{ fontWeight: "700" }}>
                {data.totalaxedroppercent}%
              </Text>
              <Text size="13px">{data.totalaxedrop.toLocaleString()}</Text>
            </FlexColumn>
          }
          bottomText="Drops"
          blur={viewType < 2}
        />
        <StatBlock
          topText={
            <FlexColumn align="center">
              <Text size="20px" style={{ fontWeight: "700" }}>
                {data.totalaxefoulpercent}%
              </Text>
              <Text size="13px">{data.totalaxefoul.toLocaleString()}</Text>
            </FlexColumn>
          }
          bottomText="Faults"
          blur={viewType < 2}
        />
      </FlexRow>
    </>
  );
};

export default ScoremagicStatsAxethrowing;
